<script lang="ts">
	//Hooks
	import { slide } from 'svelte/transition';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { validate_ip } from '../../../helpers/validators';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Alert, ToggleV2, Checkbox, Container, Input, InputV2 } from '@Shelly/shelly-design-system';

	export let open: boolean, settings: { ip: string; mask: string; gw: string; dns: string };
	export let showAlert: boolean = false;
	export let withoutBackground: boolean = false;
	export let disabledForm: boolean = false;
	export let removeBottomMargin: boolean = false;
	export let removePaddings: boolean = false;

	settings.ip = settings.ip || '192.168.0.';
	settings.mask = settings.mask || '255.255.255.0';
	settings.gw = settings.gw || settings.ip.replace(/\.[^.]*$/, '.1');

	export const validate = (skipGatewayIfCloudDisabled = false) => {
		errors.ip = !validate_ip(settings.ip);
		errors.mask = !validate_ip(settings.mask);
		errors.gw = !validate_ip(settings.gw);
		errors.dns = settings.dns && settings.dns.length > 0 && !validate_ip(settings.dns);
		errors.skipGw = skipGatewayIfCloudDisabled && errors.gw && settings.gw == '';
		return Object.values(errors).find((a) => a) ? false : settings;
	};

	const reset = () => {
		Object.keys(errors).forEach((v) => (errors[v] = false));
	};

	$: InputC = $showNewLayout ? InputV2 : Input;

	let errors = { ip: false, mask: false, gw: false, dns: false, skipGw: false };
	const errorsLabels = {
		ip: $format('wifi_ip_format_err_toast', {
			default: 'Not a valid IP format.',
		}),
		mask: $format('wifi_netmask_format_err_toast', {
			default: 'Not a valid netmask format.',
		}),
		gw: $format('wifi_gw_format_err_toast', {
			default: 'Not a valid gateway format!',
		}),
		dns: $format('wifi_ip_format_err_toast', {
			default: 'Not a valid IP format.',
		}),
		skipGw: $format('wifi_cloud_must_be_disabled', {
			default: 'Cloud must be disabled, if you want to set static IP without gateway!',
		}),
	};
</script>

<Container
	class={classMap({
		'mb-s': !removeBottomMargin,
		'border-color-transparent': withoutBackground,
	})}
	padding={!withoutBackground && !removePaddings ? 'xs' : '0'}
	type={withoutBackground ? 'borderDashed' : 'base'}
	noScroll
>
	{#if showAlert}
		<Alert
			class="mb-s"
			heading={$format('alert_heading_static_ip_address_recommended', {
				default: 'Static IP address is recommended.',
			})}
		/>
	{/if}

	{#if $showNewLayout}
		<ToggleV2
			size="m"
			bind:checked={open}
			on:click={reset}
			disabled={disabledForm}
			id="toggle-04jbza8"
		>
			{$format('checkbox_text_wifi_set_static', {
				default: 'Set static IP address.',
			})}
		</ToggleV2>
	{:else}
		<Checkbox
			size="m"
			bind:checked={open}
			on:click={reset}
			disabled={disabledForm}
			id="checkbox-04jbza8"
		>
			{$format('checkbox_text_wifi_set_static', {
				default: 'Set static IP address.',
			})}
		</Checkbox>
	{/if}
	{#if open}
		<div
			class={classMap({
				'mt-s-plus': $showNewLayout,
				'cursor-not-allowed': disabledForm,
			})}
			transition:slide={{ duration: 200 }}
		>
			<svelte:component
				this={InputC}
				aria-labelledby="input-a4gn8xr"
				size="m"
				class="mb-s"
				disabled={disabledForm}
				bind:value={settings.ip}
				error={errors.ip ? errorsLabels.ip : ''}
				label="IP address"
				icon={null}
				on:input={() => (errors.ip = false)}
				id="input-a4gn8xr"
			/>
			<svelte:component
				this={InputC}
				aria-labelledby="input-uo6tcif"
				size="m"
				class="mb-s"
				disabled={disabledForm}
				bind:value={settings.mask}
				error={errors.mask ? errorsLabels.mask : ''}
				label="Mask 255.255.255.0"
				icon={null}
				on:input={() => (errors.mask = false)}
				id="input-uo6tcif"
			/>
			<svelte:component
				this={InputC}
				aria-labelledby="input-tvaw9a7"
				size="m"
				class="mb-s"
				disabled={disabledForm}
				bind:value={settings.gw}
				error={errors.skipGw ? errorsLabels.skipGw : errors.gw ? errorsLabels.gw : ''}
				label="GW 192.168.0.1"
				icon={null}
				on:input={() => {
					errors.gw = false;
					errors.skipGw = false;
				}}
				id="input-tvaw9a7"
			/>
			<svelte:component
				this={InputC}
				aria-labelledby="input-z4sidj2"
				size="m"
				disabled={disabledForm}
				bind:value={settings.dns}
				error={errors.dns ? errorsLabels.dns : ''}
				label={$format('input_label_dns_optional', {
					default: 'DNS (optional)',
				})}
				icon={null}
				on:input={() => (errors.dns = false)}
				id="input-z4sidj2"
			/>
		</div>
	{/if}
</Container>
